var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30237 7.22791C4.87605 6.87682 4.24583 6.9378 3.89474 7.36413C3.54365 7.79046 3.60463 8.42068 4.03096 8.77177L5.30237 7.22791ZM27.969 8.77177C28.3954 8.42068 28.4564 7.79046 28.1053 7.36413C27.7542 6.9378 27.124 6.87682 26.6976 7.22791L27.969 8.77177ZM6 7.6665H26V5.6665H6V7.6665ZM27 8.6665V23.3332H29V8.6665H27ZM26 24.3332H6V26.3332H26V24.3332ZM5 23.3332V8.6665H3V23.3332H5ZM4.03096 8.77177L14.0929 17.0581L15.3643 15.5142L5.30237 7.22791L4.03096 8.77177ZM17.9071 17.0581L27.969 8.77177L26.6976 7.22791L16.6357 15.5142L17.9071 17.0581ZM6 24.3332C5.44772 24.3332 5 23.8855 5 23.3332H3C3 24.99 4.34315 26.3332 6 26.3332V24.3332ZM27 23.3332C27 23.8855 26.5523 24.3332 26 24.3332V26.3332C27.6569 26.3332 29 24.99 29 23.3332H27ZM26 7.6665C26.5523 7.6665 27 8.11422 27 8.6665H29C29 7.00965 27.6569 5.6665 26 5.6665V7.6665ZM14.0929 17.0581C15.2006 17.9703 16.7994 17.9703 17.9071 17.0581L16.6357 15.5142C16.2665 15.8183 15.7335 15.8183 15.3643 15.5142L14.0929 17.0581ZM6 5.6665C4.34315 5.6665 3 7.00965 3 8.6665H5C5 8.11422 5.44771 7.6665 6 7.6665V5.6665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1392979549a36edaa959d1ece17212ad.svg";
export { ForwardRef as ReactComponent };